import { useMutation } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { UpdateEventCommandInput, UpdateEventCommandOutput } from '@amzn/red-velvet-api';
import { useFeatures, getEnabledFeatures } from '../features';
import { getClient } from '../../utils/getClient';
import { getHttpStatusCode } from '../../utils/errorHelper';

const MUTATION_PREFIX = ['RedVelvetApi', 'updateEvent'];

export function useUpdateEvent() {
  const features = useFeatures();
  const [searchParams] = useSearchParams();
  const client = getClient(getEnabledFeatures(features, searchParams));

  return useMutation<UpdateEventCommandOutput, Error, UpdateEventCommandInput>({
    mutationKey: [...MUTATION_PREFIX],
    mutationFn: (input) => client.updateEvent(input),
    retry: (failureCount, error) => {
      if (failureCount >= 2) return false;
      const status = getHttpStatusCode(error);
      return !status || status >= 500;
    },
  });
}
